import './Ueberschriften.css'
import { Eins, Zwei, Drei, Vier, Fuenf, Sechs } from './Controls/All'
import { Dreierpasch, Viererpasch, FullHouse, KleineStrasse, GrosseStrasse, Kniffel, Chance } from './Controls/All'
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table';
import Input from 'react-bootstrap/FormControl';

const Player = (props) => {
    const [name, setName] = useState("")
    const [einsPunkte, setEinsPunkte] = useState(0)
    const [zweiPunkte, setZweiPunkte] = useState(0)
    const [dreiPunkte, setDreiPunkte] = useState(0)
    const [vierPunkte, setVierPunkte] = useState(0)
    const [fuenfPunkte, setFuenfPunkte] = useState(0)
    const [sechsPunkte, setSechsPunkte] = useState(0)
    const [dreierpasch, setDreierpasch] = useState(0)
    const [viererpasch, setViererpasch] = useState(0)
    const [fullHouse, setFullHouse] = useState(0)
    const [kleineStrasse, setKleineStrasse] = useState(0)
    const [grosseStrasse, setGrosseStrasse] = useState(0)
    const [kniffel, setKniffel] = useState(0)
    const [chance, setChance] = useState(0)
    const [bonusPunkte, setBonusPunkte] = useState(0)
    const [obenPunkte, setObenPunkte] = useState(0)
    const [untenPunkte, setUntenPunkte] = useState(0)
    const [gesamtPunkte, setGesamtPunkte] = useState(0)

    
    useEffect(() => {
        props.onPointsChange(props.playerId, gesamtPunkte)
    },[gesamtPunkte])
    useEffect(() => {
        props.onNameChange(props.playerId, name)
    },[name])
    useEffect(() => {
        const zahlenPunkte = parseInt(einsPunkte)+parseInt(zweiPunkte)+parseInt(dreiPunkte)+parseInt(vierPunkte)+parseInt(fuenfPunkte)+parseInt(sechsPunkte)
        if(zahlenPunkte>=63) {
            setBonusPunkte(35)
        } else {
            setBonusPunkte(0)
        }
        setObenPunkte(zahlenPunkte+bonusPunkte)
        setGesamtPunkte(obenPunkte+untenPunkte)
    },[einsPunkte,zweiPunkte,dreiPunkte,vierPunkte,fuenfPunkte,sechsPunkte,bonusPunkte,obenPunkte])
    useEffect(()=>{
        const specialPunkte = 0 + parseInt(dreierpasch) + parseInt(viererpasch) + parseInt(fullHouse) + parseInt(kleineStrasse) + parseInt(grosseStrasse) + parseInt(kniffel) + parseInt(chance);
        
        setUntenPunkte(specialPunkte === specialPunkte ? specialPunkte : 0)
        setGesamtPunkte(obenPunkte+(specialPunkte === specialPunkte ? specialPunkte : 0))
    },[dreierpasch, viererpasch, fullHouse, kleineStrasse, grosseStrasse, kniffel, chance, untenPunkte])
    
    return (
        <Table className="ueberschriftenTable text-center">
            <tbody>
            <tr><td className="ueberschriftenCell"><Input onChange={e => setName(e.target.value)} className='text-center' type="text"></Input></td></tr>
            {name !== "" && <tr><td className="ueberschriftenCell"><Eins onSelectChange={setEinsPunkte} /></td></tr>}
            {name !== "" && <tr><td className="ueberschriftenCell"><Zwei onSelectChange={setZweiPunkte} /></td></tr>}
            {name !== "" && <tr><td className="ueberschriftenCell"><Drei onSelectChange={setDreiPunkte} /></td></tr>}
            {name !== "" && <tr><td className="ueberschriftenCell"><Vier onSelectChange={setVierPunkte} /></td></tr>}
            {name !== "" && <tr><td className="ueberschriftenCell"><Fuenf onSelectChange={setFuenfPunkte} /></td></tr>}
            {name !== "" && <tr><td className="ueberschriftenCell"><Sechs onSelectChange={setSechsPunkte} /></td></tr>}
            {name !== "" && <tr><td className="ueberschriftenCell">{bonusPunkte}</td></tr>}
            {name !== "" && <tr className="grayCell"><td className="ueberschriftenCell">{obenPunkte}</td></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"><Dreierpasch onSelectChange={setDreierpasch} /></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"><Viererpasch onSelectChange={setViererpasch} /></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"><FullHouse onSelectChange={setFullHouse} /></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"><KleineStrasse onSelectChange={setKleineStrasse} /></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"><GrosseStrasse onSelectChange={setGrosseStrasse} /></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"><Kniffel onSelectChange={setKniffel} /></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"><Chance onSelectChange={setChance} /></th></tr>}
            {name !== "" && <tr><th className="ueberschriftenCell"></th></tr>}
            {name !== "" && <tr className="grayCell"><th className="ueberschriftenCell">{untenPunkte}</th></tr>}
            {name !== "" && <tr className="grayCell"><th className="ueberschriftenCell">{gesamtPunkte}</th></tr>}
            {name !== "" && <tr className=""><th className="ueberschriftenCell text-danger">{props.platzierung}</th></tr>}

            </tbody>
        </Table>
    )
}

export default Player;